import React from 'react';
import { Link } from 'react-router-dom';

const BlogPostCard = ({ post }) => {
  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow">
      <Link 
            to={`/blog/${post.id}`} 
            className="text-nihal-primary font-medium hover:underline"
          ><img 
        src={post.image || '/placeholder-image.jpg'} 
        alt={post.title} 
        className="w-full h-48 object-cover"
      /></Link>
      <div className="p-6">
        <span className="inline-block px-3 py-1 bg-nihal-secondary text-dark text-sm rounded-full mb-3">
          {post.category}
        </span>
        <h3 className="text-xl font-bold text-nihal-l mb-3">{post.title}</h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-3">{post.excerpt}</p>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">
            {post.createdAt?.toDate ? new Date(post.createdAt.toDate()).toLocaleDateString() : 'N/A'}
          </span>
          <Link 
            to={`/blog/${post.id}`} 
            className="text-nihal-primary font-medium hover:underline"
          >
            <button className="btn btn-primary px-3 py-3 text-sm">Devamını Oku</button>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default BlogPostCard;